/* =========================================================================
   Gutsi - publishes --gutsi-ticker-offset for assets/claude-ticker.css.

   Value is how much of the top ticker is still on screen:
     max(0, tickerHeight - scrollY)
   so the fixed nav rests below the banner and slides up to 0 as the banner
   scrolls away. See claude-ticker.css for why this is not plain CSS.

   NO requestAnimationFrame HERE, DELIBERATELY. The first version batched the
   scroll handler into a rAF and the offset then never updated at all on a
   hidden or backgrounded page - rAF simply does not fire there, so the queued
   flag latched on and every later scroll was dropped. assets/claude-hero.js
   hit the same trap on 9 Sep and had its fade moved off rAF for the same
   reason. Do not reintroduce it.

   Instead the ticker height is CACHED and only re-measured on resize, load
   and webfont settle. That leaves the scroll path as arithmetic plus a
   guarded property write - no layout read per scroll - which is cheap enough
   to run synchronously in a passive listener.
   ========================================================================= */
(function () {
  'use strict';

  function boot() {
    var ticker = document.querySelector('.gutsi-ticker-section');
    var nav = document.querySelector('.main-navbar');
    if (!ticker || !nav) return;

    var root = document.documentElement;
    var tickerH = 0;
    var last = -1;

    function scrollTop() {
      return window.scrollY || window.pageYOffset ||
        (document.documentElement && document.documentElement.scrollTop) || 0;
    }

    function apply() {
      var offset = Math.round(Math.max(0, tickerH - scrollTop()));
      if (offset === last) return;
      last = offset;
      root.style.setProperty('--gutsi-ticker-offset', offset + 'px');
    }

    /* The only layout read. The ticker re-wraps at narrow widths and the
       theme editor can change its padding live, so re-measure on resize. */
    function measure() {
      tickerH = ticker.offsetHeight;
      apply();
    }

    measure();
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
